import {SVGProps} from 'react';

export const FacebookSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill="#D9D9D9" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.4008 21L9.375 13.125H6V9.75H9.375V7.5C9.375 4.4634 11.2554 3 13.9643 3C15.2619 3 16.3771 3.0966 16.7021 3.13978V6.3132L14.8233 6.31406C13.3501 6.31406 13.0649 7.01411 13.0649 8.04139V9.75H17.25L16.125 13.125H13.0648V21H9.4008Z"
      fill="#030303"
    />
  </svg>
);
export const InstagramSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill="#D9D9D9" />
    <path
      d="M7.11225 4.89691C6.6138 5.09076 6.19227 5.34921 5.77074 5.77074C5.34921 6.18919 5.09076 6.6138 4.89691 7.10917C4.70923 7.58916 4.58308 8.13992 4.54615 8.94606C4.50923 9.75219 4.5 10.0106 4.5 12.066C4.5 14.1213 4.50923 14.3798 4.54615 15.1859C4.58308 15.9921 4.7123 16.5428 4.89691 17.0228C5.09076 17.5213 5.34921 17.9428 5.77074 18.3643C6.19227 18.7858 6.6138 19.0443 7.11225 19.2381C7.59224 19.4258 8.143 19.552 8.94913 19.5889C9.75527 19.6258 10.0137 19.6351 12.0691 19.6351C14.1244 19.6351 14.3829 19.6258 15.189 19.5889C15.9951 19.552 16.5459 19.4228 17.0259 19.2381C17.5243 19.0443 17.9459 18.7858 18.3674 18.3643C18.7889 17.9428 19.0474 17.5213 19.2412 17.0228C19.4289 16.5428 19.5551 15.9921 19.592 15.1859C19.6289 14.3798 19.6381 14.1213 19.6381 12.066C19.6381 10.0106 19.6289 9.75219 19.592 8.94606C19.5551 8.13992 19.4258 7.58916 19.2412 7.10917C19.0474 6.6138 18.7889 6.18919 18.3705 5.77074C17.9489 5.34921 17.5274 5.09076 17.029 4.89691C16.549 4.70923 15.9982 4.58308 15.1921 4.54615C14.3859 4.50923 14.1275 4.5 12.0721 4.5C10.0168 4.5 9.75835 4.50923 8.95221 4.54615C8.143 4.58 7.59224 4.70923 7.11225 4.89691ZM15.1275 5.90612C15.8659 5.93997 16.2659 6.06304 16.5336 6.16766C16.8874 6.30611 17.1397 6.46919 17.4043 6.7338C17.6689 6.99841 17.832 7.25071 17.9705 7.60455C18.0751 7.87223 18.1982 8.27223 18.232 9.01067C18.2689 9.80758 18.2751 10.0476 18.2751 12.0691C18.2751 14.0906 18.2659 14.3306 18.232 15.1275C18.1982 15.8659 18.0751 16.2659 17.9705 16.5336C17.832 16.8874 17.6689 17.1397 17.4043 17.4043C17.1397 17.6689 16.8874 17.832 16.5336 17.9705C16.2659 18.0751 15.8659 18.1982 15.1275 18.232C14.3306 18.2689 14.0906 18.2751 12.0691 18.2751C10.0476 18.2751 9.80758 18.2659 9.01067 18.232C8.27222 18.1982 7.87223 18.0751 7.60455 17.9705C7.25071 17.832 6.99841 17.6689 6.7338 17.4043C6.46919 17.1397 6.30611 16.8874 6.16766 16.5336C6.06304 16.2659 5.93997 15.8659 5.90612 15.1275C5.8692 14.3306 5.86305 14.0906 5.86305 12.0691C5.86305 10.0476 5.87228 9.80758 5.90612 9.01067C5.93997 8.27223 6.06304 7.87223 6.16766 7.60455C6.30611 7.25071 6.46919 6.99841 6.7338 6.7338C6.99841 6.46919 7.25071 6.30611 7.60455 6.16766C7.87223 6.06304 8.27222 5.93997 9.01067 5.90612C9.80758 5.8692 10.0476 5.86305 12.0691 5.86305C14.0906 5.86305 14.3306 5.8692 15.1275 5.90612Z"
      fill="url(#paint0_radial_217_1960)"
    />
    <path
      d="M8.18286 12.0691C8.18286 14.2167 9.92436 15.9551 12.0689 15.9551C14.2135 15.9551 15.955 14.2136 15.955 12.0691C15.955 9.92448 14.2166 8.18298 12.0689 8.18298C9.92129 8.18298 8.18286 9.92141 8.18286 12.0691ZM14.592 12.0691C14.592 13.4629 13.4627 14.5921 12.0689 14.5921C10.6751 14.5921 9.54591 13.4629 9.54591 12.0691C9.54591 10.6752 10.6751 9.54603 12.0689 9.54603C13.4627 9.54603 14.592 10.6752 14.592 12.0691Z"
      fill="url(#paint1_radial_217_1960)"
    />
    <path
      d="M16.112 8.93681C16.6133 8.93681 17.0197 8.53043 17.0197 8.02913C17.0197 7.52784 16.6133 7.12146 16.112 7.12146C15.6107 7.12146 15.2043 7.52784 15.2043 8.02913C15.2043 8.53043 15.6107 8.93681 16.112 8.93681Z"
      fill="#030303"
    />
    <defs>
      <radialGradient
        id="paint0_radial_217_1960"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.77544 18.2494) rotate(-3.00009) scale(21.8861 18.603)"
      >
        <stop stopColor="#030303" />
        <stop offset="0.2634" stopColor="#030303" />
        <stop offset="0.6091" stopColor="#030303" />
        <stop offset="1" stopColor="#030303" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_217_1960"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.32382 15.2424) rotate(-3.00009) scale(11.2388 9.55288)"
      >
        <stop stopColor="#030303" />
        <stop offset="0.333333" stopColor="#030303" />
        <stop offset="0.666667" stopColor="#030303" />
        <stop offset="1" stopColor="#030303" />
      </radialGradient>
    </defs>
  </svg>
);

export const XSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill="#D9D9D9" />
    <g clipPath="url(#clip0_1023_965)">
      <path
        d="M13.8097 10.4478L18.929 4.625H17.716L13.2689 9.6798L9.71963 4.625H5.625L10.9934 12.2694L5.625 18.375H6.83795L11.5313 13.0357L15.2804 18.375H19.375L13.8097 10.4478ZM12.1478 12.3365L11.6031 11.5749L7.27537 5.51976H9.1387L12.6323 10.4082L13.1748 11.1699L17.7154 17.5238H15.8521L12.1478 12.3365Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1023_965">
        <rect width="15" height="15" fill="white" transform="translate(5 4)" />
      </clipPath>
    </defs>
  </svg>
);

export const GoogleSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 25 25"
    fill="none"
  >
    <g clipPath="url(#clip0_554_491)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9998 12.7778C24.9998 11.75 24.9147 11 24.7305 10.2222H12.7549V14.861H19.7843C19.6426 16.0139 18.8773 17.75 17.1766 18.9166L17.1528 19.0719L20.9392 21.9466L21.2016 21.9722C23.6108 19.7917 24.9998 16.5833 24.9998 12.7778Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.755 25C16.1988 25 19.0899 23.8889 21.2017 21.9722L17.1767 18.9166C16.0996 19.6527 14.654 20.1666 12.755 20.1666C9.38198 20.1666 6.5192 17.9861 5.49866 14.9723L5.34912 14.9847L1.41186 17.9708L1.36035 18.1111C3.45782 22.1944 7.76626 25 12.755 25Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49872 14.9723C5.22948 14.1945 5.07359 13.3611 5.07359 12.5C5.07359 11.6389 5.22941 10.8056 5.48456 10.0278L5.47744 9.86213L1.49089 6.82801L1.36048 6.88883C0.495994 8.58331 0 10.4861 0 12.5C0 14.5139 0.496071 16.4165 1.36048 18.111L5.4988 14.9722"
        fill="#FBBC04"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.755 4.83331C15.1501 4.83331 16.7656 5.84723 17.6869 6.69451L21.2867 3.25005C19.0759 1.23615 16.1988 7.51019e-05 12.755 7.51019e-05C7.76626 7.51019e-05 3.4579 2.8056 1.36035 6.88891L5.48451 10.0279C6.5192 7.01401 9.38198 4.83338 12.755 4.83338"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_554_491">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PaystackLogo = () => (
  <svg
    height="25"
    viewBox="-125 222 600.2 106.9"
    width="100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m-45.8 232.2h-80.4c-2.7 0-5 2.3-5 5.1v9.1c0 2.8 2.3 5.1 5 5.1h80.4c2.8 0 5-2.3 5.1-5.1v-9c0-2.9-2.3-5.2-5.1-5.2zm0 50.5h-80.4c-1.3 0-2.6.5-3.5 1.5-1 1-1.5 2.2-1.5 3.6v9.1c0 2.8 2.3 5.1 5 5.1h80.4c2.8 0 5-2.2 5.1-5.1v-9.1c-.1-2.9-2.3-5.1-5.1-5.1zm-35.1 25.2h-45.3c-1.3 0-2.6.5-3.5 1.5s-1.5 2.2-1.5 3.6v9.1c0 2.8 2.3 5.1 5 5.1h45.2c2.8 0 5-2.3 5-5v-9.1c.1-3-2.1-5.3-4.9-5.2zm40.2-50.5h-85.5c-1.3 0-2.6.5-3.5 1.5s-1.5 2.2-1.5 3.6v9.1c0 2.8 2.3 5.1 5 5.1h85.4c2.8 0 5-2.3 5-5.1v-9.1c.1-2.8-2.2-5-4.9-5.1zm0 0"
      fill="#00c3f7"
    />
    <path
      d="m52.8 252.6c-2.5-2.6-5.4-4.6-8.7-6s-6.8-2.1-10.4-2.1c-3.5-.1-6.9.7-10.1 2.2-2.1 1-4 2.4-5.6 4.1v-1.6c0-.8-.3-1.6-.8-2.2s-1.3-1-2.2-1h-11.1c-.8 0-1.6.3-2.1 1-.6.6-.9 1.4-.8 2.2v74.8c0 .8.3 1.6.8 2.2.6.6 1.3.9 2.1.9h11.4c.8 0 1.5-.3 2.1-.9.6-.5 1-1.3.9-2.2v-25.6c1.6 1.8 3.7 3.1 6 3.9 3 1.1 6.1 1.7 9.3 1.7 3.6 0 7.2-.7 10.5-2.1s6.3-3.4 8.8-6c2.6-2.7 4.6-5.9 6-9.4 1.6-3.9 2.3-8.1 2.2-12.3.1-4.2-.7-8.4-2.2-12.4-1.5-3.3-3.5-6.5-6.1-9.2zm-10.2 27.1c-.6 1.6-1.5 3-2.7 4.3-2.3 2.5-5.6 3.9-9 3.9-1.7 0-3.4-.3-5-1.1-1.5-.7-2.9-1.6-4.1-2.8s-2.1-2.7-2.7-4.3c-1.3-3.4-1.3-7.1 0-10.5.6-1.6 1.6-3 2.7-4.2 1.2-1.2 2.6-2.2 4.1-2.9 1.6-.7 3.3-1.1 5-1.1 1.8 0 3.4.3 5.1 1.1 1.5.7 2.9 1.6 4 2.8 1.2 1.2 2 2.6 2.7 4.2 1.2 3.5 1.1 7.2-.1 10.6zm79.6-33.6h-11.3c-.8 0-1.6.3-2.1.9-.6.6-.9 1.4-.9 2.3v1.4c-1.4-1.7-3.2-3-5.1-3.9-3.1-1.5-6.5-2.2-9.9-2.2-7.3 0-14.2 2.9-19.4 8-2.7 2.7-4.8 5.9-6.2 9.4-1.6 3.9-2.4 8.1-2.3 12.4-.1 4.2.7 8.4 2.3 12.4 1.5 3.5 3.5 6.7 6.2 9.4 5.1 5.2 12.1 8.1 19.3 8.1 3.4.1 6.8-.7 9.9-2.2 1.9-1 3.8-2.3 5.2-3.9v1.5c0 .8.3 1.6.9 2.2.6.5 1.3.9 2.1.9h11.3c.8 0 1.6-.3 2.1-.9.6-.6.9-1.4.9-2.2v-50.3c0-.8-.3-1.6-.8-2.2-.6-.7-1.4-1.1-2.2-1.1zm-15.3 33.6c-.6 1.6-1.5 3-2.7 4.3-1.2 1.2-2.5 2.2-4 2.9-3.2 1.5-6.9 1.5-10.1 0-1.5-.7-2.9-1.7-4.1-2.9s-2.1-2.7-2.7-4.3c-1.2-3.4-1.2-7.1 0-10.5.6-1.6 1.5-2.9 2.7-4.2 1.2-1.2 2.5-2.2 4.1-2.9 3.2-1.5 6.9-1.5 10 0 1.5.7 2.9 1.6 4 2.8s2 2.6 2.7 4.2c1.4 3.5 1.4 7.2.1 10.6zm127.9-6.8c-1.6-1.4-3.5-2.6-5.5-3.4-2.1-.9-4.4-1.5-6.6-2l-8.6-1.7c-2.2-.4-3.8-1-4.6-1.7-.7-.5-1.2-1.3-1.2-2.2s.5-1.7 1.6-2.4c1.5-.8 3.1-1.2 4.8-1.1 2.2 0 4.4.5 6.4 1.3 2 .9 3.9 1.8 5.7 3 2.5 1.6 4.7 1.3 6.2-.5l4.1-4.7c.8-.8 1.2-1.8 1.3-2.9-.1-1.2-.7-2.2-1.6-3-1.7-1.5-4.5-3.1-8.2-4.7s-8.4-2.4-13.9-2.4c-3.4-.1-6.7.4-9.9 1.4-2.7.9-5.3 2.2-7.6 3.9-2.1 1.6-3.7 3.6-4.9 6-1.1 2.3-1.7 4.8-1.7 7.3 0 4.7 1.4 8.5 4.2 11.3s6.5 4.7 11.1 5.6l9 2c1.9.3 3.9.9 5.7 1.8 1 .4 1.6 1.4 1.6 2.5 0 1-.5 1.9-1.6 2.7s-2.9 1.3-5.3 1.3-4.9-.5-7.1-1.6c-2.1-1-4-2.3-5.8-3.8-.8-.6-1.6-1.1-2.6-1.5-1-.3-2.3 0-3.6 1.1l-4.9 3.7c-1.4 1-2.1 2.7-1.7 4.3.3 1.7 1.6 3.3 4.1 5.2 6.2 4.2 13.6 6.4 21.1 6.2 3.5 0 7-.4 10.3-1.4 2.9-.9 5.6-2.2 8-4 2.2-1.6 4-3.7 5.2-6.2 1.2-2.4 1.8-5 1.8-7.7.1-2.4-.4-4.8-1.4-7-1-1.6-2.3-3.3-3.9-4.7zm49.4 13.7c-.5-.9-1.4-1.5-2.5-1.7-1 0-2.1.3-2.9.9-1.4.9-3 1.4-4.6 1.5-.5 0-1.1-.1-1.6-.2-.6-.1-1.1-.4-1.5-.8-.5-.5-.9-1.1-1.2-1.7-.4-1-.6-2-.5-3v-20.5h14.6c.9 0 1.7-.4 2.3-1s1-1.3 1-2.2v-8.7c0-.9-.3-1.7-1-2.2-.6-.6-1.4-.9-2.2-.9h-14.7v-14c0-.8-.3-1.7-.9-2.2s-1.3-.8-2.1-.9h-11.4c-.8 0-1.6.3-2.2.9s-1 1.4-1 2.2v14h-6.5c-.8 0-1.6.3-2.2 1-.5.6-.8 1.4-.8 2.2v8.7c0 .8.3 1.6.8 2.2.5.7 1.3 1 2.2 1h6.5v24.4c-.1 2.9.5 5.8 1.7 8.4 1.1 2.2 2.5 4.1 4.4 5.7 1.8 1.5 3.9 2.6 6.2 3.2 2.3.7 4.7 1.1 7.1 1.1 3.1 0 6.3-.5 9.3-1.5 2.8-.9 5.3-2.5 7.3-4.6 1.3-1.3 1.4-3.4.4-4.9zm61.8-40.5h-11.3c-.8 0-1.5.3-2.1.9s-.9 1.4-.9 2.3v1.4c-1.4-1.7-3.1-3-5.1-3.9-3.1-1.5-6.5-2.2-9.9-2.2-7.3 0-14.2 2.9-19.4 8-2.7 2.7-4.8 5.9-6.2 9.4-1.6 3.9-2.4 8.1-2.3 12.3-.1 4.2.7 8.4 2.3 12.4 1.4 3.5 3.6 6.7 6.2 9.4 5.1 5.2 12 8.1 19.3 8.1 3.4.1 6.8-.7 9.9-2.1 2-1 3.8-2.3 5.2-3.9v1.5c0 .8.3 1.6.9 2.1.6.6 1.3.9 2.1.9h11.3c1.7 0 3-1.3 3-3v-50.3c0-.8-.3-1.6-.8-2.2-.5-.7-1.3-1.1-2.2-1.1zm-15.2 33.6c-.6 1.6-1.5 3-2.7 4.3-1.2 1.2-2.5 2.2-4 2.9-1.6.7-3.3 1.1-5.1 1.1s-3.4-.4-5-1.1c-1.5-.7-2.9-1.7-4.1-2.9s-2.1-2.7-2.6-4.3c-1.2-3.4-1.2-7.1 0-10.5.6-1.6 1.5-3 2.6-4.2 1.2-1.2 2.6-2.2 4.1-2.9 1.6-.7 3.3-1.1 5-1.1s3.4.3 5.1 1.1c1.5.7 2.8 1.6 4 2.8s2.1 2.6 2.7 4.2c1.3 3.4 1.3 7.2 0 10.6zm77.2 6.1-6.5-5c-1.2-1-2.4-1.3-3.4-.9-.9.4-1.7 1-2.4 1.7-1.4 1.7-3.1 3.2-4.9 4.5-2 1.1-4.1 1.7-6.3 1.5-2.6 0-5-.7-7.1-2.2s-3.7-3.5-4.5-6c-.6-1.7-.9-3.4-.9-5.1 0-1.8.3-3.5.9-5.3.6-1.6 1.4-3 2.6-4.2s2.5-2.2 4-2.8c1.6-.7 3.3-1.1 5.1-1.1 2.2-.1 4.4.5 6.3 1.6 1.9 1.2 3.5 2.7 4.9 4.5.6.7 1.4 1.3 2.3 1.7 1 .4 2.2.1 3.4-.9l6.5-4.9c.8-.5 1.4-1.3 1.7-2.2.4-1 .3-2.1-.3-3-2.5-3.9-5.9-7.1-10-9.4-4.3-2.4-9.4-3.7-15.1-3.7-4 0-8 .8-11.8 2.3-3.6 1.5-6.8 3.6-9.5 6.3s-4.9 5.9-6.4 9.5c-3.1 7.5-3.1 15.9 0 23.4 1.5 3.5 3.6 6.8 6.4 9.4 5.7 5.6 13.3 8.6 21.3 8.6 5.7 0 10.8-1.3 15.1-3.7 4.1-2.3 7.6-5.5 10.1-9.5.5-.9.6-2 .3-2.9-.4-.8-1-1.6-1.8-2.2zm60.2 11.7-17.9-26.2 15.3-20.2c.7-.9 1-2.2.6-3.3-.3-.8-1-1.6-2.9-1.6h-12.1c-.7 0-1.4.2-2 .5-.8.4-1.4 1-1.8 1.7l-12.2 17.1h-2.9v-40.4c0-.8-.3-1.6-.9-2.2s-1.3-.9-2.1-.9h-11.3c-.8 0-1.6.3-2.2.9s-.9 1.3-.9 2.2v74.5c0 .9.3 1.6.9 2.2s1.4.9 2.2.9h11.3c.8 0 1.6-.3 2.1-.9.6-.6.9-1.4.9-2.2v-19.7h3.2l13.3 20.4c.8 1.5 2.3 2.4 3.9 2.4h12.7c1.9 0 2.7-.9 3.1-1.7.5-1.2.4-2.5-.3-3.5zm-281.8-51.4h-12.7c-1 0-1.9.3-2.6 1-.6.6-1 1.3-1.2 2.1l-9.4 34.8h-2.3l-10-34.8c-.2-.7-.5-1.4-1-2.1-.6-.7-1.4-1.1-2.3-1.1h-12.9c-1.7 0-2.7.5-3.2 1.7-.3 1-.3 2.1 0 3.1l16 49c.3.7.6 1.5 1.2 2 .6.6 1.5.9 2.4.9h6.8l-.6 1.6-1.5 4.5c-.5 1.4-1.3 2.6-2.5 3.5-1.1.8-2.4 1.3-3.8 1.2-1.2 0-2.3-.3-3.4-.7-1.1-.5-2.1-1.1-3-1.8-.8-.6-1.8-.9-2.9-.9h-.1c-1.2.1-2.3.7-2.9 1.8l-4 5.9c-1.6 2.6-.7 4.2.3 5.1 2.2 2 4.7 3.5 7.5 4.4 3.1 1.1 6.3 1.6 9.5 1.6 5.8 0 10.6-1.6 14.3-4.7 3.8-3.4 6.7-7.8 8.1-12.8l18.6-60.6c.4-1.1.5-2.2.1-3.2-.1-.7-.8-1.5-2.5-1.5zm0 0"
      fill="white"
    />
  </svg>
);

export const LogoSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="55"
    height="55"
    viewBox="0 0 667.97809 667.97839"
    version="1.1"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs2"></defs>
    <g id="layer1" transform="translate(-130.14665,-166.01077)">
      <path
        d="m 166.61921,212.11196 c 0,0 -6.87545,24.78942 -6.87545,64.51436 0,39.72495 5.34759,74.48446 10.69518,79.4499 5.34759,4.96545 42.78053,9.9309 85.56106,9.9309 42.78039,0 80.21305,-4.96545 85.56079,-9.9309 5.34772,-4.96544 10.69544,-39.72495 10.69544,-79.4499 0,-39.72494 -6.87545,-64.51436 -6.87545,-64.51436 m -178.76158,0 c 15.92327,1.44289 50.7437,2.63536 89.3808,2.63536 38.63724,0 73.45724,-1.19247 89.38078,-2.63536 m -178.76158,0 c -4.22633,-0.38295 -7.12144,-0.7838 -8.40331,-1.18436 -6.11157,-1.90986 -12.22301,-15.27875 -12.22301,-30.5575 0,-15.27876 6.11144,-28.64765 12.22301,-30.5575 6.11147,-1.90987 48.892,-3.81972 97.78411,-3.81972 48.89266,0 91.67305,1.90985 97.78395,3.81972 6.11226,1.90985 12.22317,15.27874 12.22317,30.5575 0,15.27875 -6.11091,28.64764 -12.22317,30.55751 -1.28159,0.40055 -4.17614,0.8014 -8.40317,1.18436 m -116.88257,51.5479 c 0,0 6.03052,9.69651 26.65685,9.69651 20.62634,0 28.86869,-9.29848 28.86869,-9.29848"
        stroke="#000000"
        strokeWidth="20.6264"
        strokeLinecap="round"
        strokeLinejoin="round"
        id="path132"
        style={{
          display: 'none',
          fill: '#fefefe',
        }}
      />
      <g id="g1049">
        <path
          d="m 298.48811,478.09363 c 96.21157,60.60654 220.64149,56.30929 331.29516,0"
          stroke="gray"
          strokeWidth="34.6589"
          strokeLinecap="round"
          strokeLinejoin="round"
          id="path1097"
          style={{
            fill: 'none',
            stroke: '#00000',
            strokeWidth: 75,
            strokeDasharray: 'none',
          }}
          // style='fill:none;fill-opacity:1;stroke:#000000;strokeWidth:75;stroke-dasharray:none;stroke-opacity:1'
        />
        <path
          d="m 167.64665,557.18331 v 31.76443 c 0,148.24238 59.29802,207.54148 207.54291,207.54148 h 177.89371 c 148.24592,0 207.54146,-59.2991 207.54146,-207.54148 v -177.8944 c 0,-148.24487 -59.29554,-207.54256 -207.54146,-207.54256 H 375.18956 c -148.24489,0 -207.54291,55.48726 -207.54291,203.73214"
          stroke="gray"
          strokeWidth="35.7728"
          strokeLinecap="round"
          strokeLinejoin="round"
          id="path1099"
          style={{
            fill: 'none',
            stroke: '#00000',
            strokeWidth: 75,
            strokeDasharray: 'none',
          }}
        />
      </g>
    </g>
  </svg>
);
